export default "__VITE_ASSET__BuV4P3pS__"